import { ajax } from 'rxjs/ajax';
import { pluck } from 'rxjs/operators';

import env from 'config/env';
import { baseGetRequest } from '../baseRequest';

const { TRETAIL_API_BASE_URL } = env;

export default function getProfileDetails$({ locale }) {
	return ajax({
		...baseGetRequest({ locale }),
		url: `${TRETAIL_API_BASE_URL}/profile`,
	}).pipe(pluck('response'));
}
